<template>
  <div>
    <LicensePlateComponent v-for="(licensePlate, index) in licensePlates" :key="'license-plate-' + index"
                           :license-plate="licensePlate"/>
    <div v-for="(coverage, index) in coverages" :key="'coverage-' + index">
        Dekking {{ coverage }}
    </div>
    <div v-for="(policyHolder, index) in policyHolders" :key="'policy-holder-' + index">
        <AccountIcon/>
        {{ policyHolder }}
        {{ formattedDate(afdMessage.data.names[index].dateOfBirth) }}
    </div>
    <div v-for="(insuredPerson, index) in insuredPersons" :key="'insured-person-' + index">
        <AccountIcon/>
        {{ insuredPerson }}
    </div>
    <div v-for="(attachment, index) in attachments" :key="'attachment-' + index">
        <AttachmentIcon/>
        {{ attachment }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LicensePlateComponent from '~/components/LicensePlateComponent'
import moment from 'moment';
import DateFormatEnum from "~/enums/DateFormatEnum";
// import store from '../store';

export default {
  name: 'AFDMessageDescriptionComponent',
  props: {
    afdMessage: {
      type: Object,
      required: true
    }
  },
  components: { LicensePlateComponent },
  data () {
    return {
      moment,
    }
  },
  computed: {
    ...mapGetters({
    }),
    licensePlates () {
      return this.afdMessage.data.licensePlates || []
    },
    policyHolders () {
      return this.afdMessage.data.policyHolders || []
    },
    insuredPersons () {
      return this.afdMessage.data.insuredPersons || []
    },
    coverages () {
      return this.afdMessage.data.coverages || []
    },
    attachments () {
      return this.afdMessage.data.attachments || []
    },
  },
  methods: {
    formattedDate (date) {
      return date !== undefined && date !== null
          ? moment(date, DateFormatEnum.DATE).format(DateFormatEnum.DISPLAY_DATE)
          : '';
    },
  }
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
